import { billingRequest } from "./billing-client";

export interface ProductDto {
  id: string;
  code: string;
  sku: string;
  barcode: string | null;
  name: string;
  description: string | null;
  itemType: string;
  sellingPrice: string;
  purchasePrice: string;
  quantityOnHand: string;
  alertQuantity: string;
  status: string;
  inventoryProductId: string | null;
  createdAt: string;
  category: { id: string; code: string; name: string } | null;
  unit: { id: string; code: string; name: string; symbol: string };
  taxRate: { id: string; code: string; name: string; rate: string } | null;
}

export interface ProductListResponse {
  items: ProductDto[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

export interface ProductFormOptions {
  categories: { id: string; code: string; name: string }[];
  units: { id: string; code: string; name: string; symbol: string }[];
  taxRates: { id: string; code: string; name: string; rate: string }[];
}

export interface CreateProductPayload {
  code: string;
  sku: string;
  name: string;
  barcode?: string;
  description?: string;
  itemType?: "PRODUCT" | "SERVICE";
  categoryId?: string;
  unitId: string;
  taxRateId?: string;
  sellingPrice: number;
  purchasePrice?: number;
  quantityOnHand?: number;
}

export const productsApi = {
  list: (params?: { page?: number; limit?: number; itemType?: string }) => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.itemType) q.set("itemType", params.itemType);
    const query = q.toString();
    return billingRequest<ProductListResponse>(`/products${query ? `?${query}` : ""}`);
  },
  formOptions: () => billingRequest<ProductFormOptions>("/products/form-options"),
  get: (id: string) => billingRequest<ProductDto>(`/products/${id}`),
  create: (payload: CreateProductPayload) =>
    billingRequest<ProductDto>("/products", { method: "POST", body: JSON.stringify(payload) }),
  update: (id: string, payload: Partial<CreateProductPayload>) =>
    billingRequest<ProductDto>(`/products/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
};
